import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=584eed44&scoped=true&"
import script from "./AccountForm.vue?vue&type=script&lang=ts&"
export * from "./AccountForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountForm.vue?vue&type=style&index=0&id=584eed44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584eed44",
  null
  
)

export default component.exports